/**
 * VENDOR MODULES
 */
import React from 'react';
import i18n from "i18n";

import GridOdd from 'shared/components/outcomes/grids/GridOdd';

/**
 * Renders the 1X2 Match Result outcomes for football
 * HOME, DRAW, AWAY
 *
 * @class  MatchResult (name)
 * @param  {Object}   props The properties
 * @return {JSX}
 */
function MatchResult(props) {
  const {
    outcomes = {},
    homeTeamName = 'Home',
    awayTeamName = 'Away',
    event,
    oddVariant = 'grid-odd-football',
  } = props;

  // Filter for market type 5001 (Match Result)
  const matchResultOutcomes = Object.values(outcomes)
    .filter(x => parseInt(x.market_type_id) === 5001);

  // Sort outcomes in HOME, DRAW, AWAY order
  const outcomeOrder = ['HOME', 'DRAW', 'AWAY'];
  const sortedOutcomes = matchResultOutcomes.sort((a, b) => {
    return outcomeOrder.indexOf(a.outcome) - outcomeOrder.indexOf(b.outcome);
  });

  // Get individual outcomes
  const homeOutcome = sortedOutcomes.find(o => o.outcome === 'HOME');
  const drawOutcome = sortedOutcomes.find(o => o.outcome === 'DRAW');
  const awayOutcome = sortedOutcomes.find(o => o.outcome === 'AWAY');

  return (
    <div className="match-result-grid">
      <div className="grid grid-cols-3 gap-3 p-3 border-b border-gray-100">
        {/* Home Win */}
        <div className="w-full">
          {homeOutcome && (
            <GridOdd
              {...{
                ...homeOutcome,
                class_names: [oddVariant, 'bg-background/80', 'w-full', 'p-4', 'min-h-[72px]'],
                market_type_group_id: 508,
                display_label: '1',
                event
              }}
            />
          )}
        </div>
        
        {/* Draw */}
        <div className="w-full">
          {drawOutcome && (
            <GridOdd
              {...{
                ...drawOutcome,
                class_names: [oddVariant, 'bg-background/80', 'w-full', 'p-4', 'min-h-[72px]'],
                market_type_group_id: 508,
                display_label: 'X',
                event
              }}
            />
          )}
        </div>
        
        {/* Away Win */}
        <div className="w-full">
          {awayOutcome && (
            <GridOdd
              {...{
                ...awayOutcome,
                class_names: [oddVariant, 'bg-background/80', 'w-full', 'p-4', 'min-h-[72px]'],
                market_type_group_id: 508,
                display_label: '2',
                event
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default MatchResult;

